<div class="container">
  <ng-container *ngTemplateOutlet="formRegister"></ng-container>
</div>

<ng-template #formRegister>
  <div style="margin: 10px 10px 0 0; display: flex; justify-content: center">
    <mat-chip-list
      #chipList
      aria-label="Fruit selection"
      style="display: flex; flex-direction: row; align-items: center"
    >
      <mat-chip
        *ngFor="let data of chipUsers"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(data)"
      >
        {{ data.nombre }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
  <form
    [formGroup]="formR"
    (ngSubmit)="formR.valid ? saveRegister(formR.value) : errorMessage()"
    style="overflow: auto"
  >
    <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
      <div style="display: flex; width: 100%; margin-top: 10px">
        <div [style.flex]="10">
          <div class="first-row">
            <div class="row-item">
              <combos
                [configuration]="combosConfigUsers"
                [reloadCombo]="reloadComboUsers"
                [required]="true"
                [filter]="true"
                [control]="formR.get('userIds')"
                [checkbox]="true"
                (changeOptionDataComplete)="getDataComboUsers($event)"
                (returnDataCombo)="returnDataComboUsers($event)"
                [disabled]="edit"
              >
              </combos>
            </div>
          </div>
          <div class="default-row" *ngIf="!exit">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Fecha Entrada</mat-label>
                <input
                  [matDatepicker]="pickerEntrada"
                  autocomplete="off"
                  matInput
                  required
                  formControlName="entryDate"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerEntrada">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #pickerEntrada
                  [touchUi]="movil ? true : false"
                ></mat-datepicker>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Hora Entrada</mat-label>
                <input
                  matInput
                  [ngxTimepicker]="pickerHE"
                  formControlName="entryTime"
                  required
                />
                <ngx-material-timepicker #pickerHE></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Fecha Salida</mat-label>
                <input
                  [matDatepicker]="pickerSalida"
                  autocomplete="off"
                  matInput
                  formControlName="exitDate"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerSalida">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #pickerSalida
                  [touchUi]="movil ? true : false"
                ></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Hora Salida</mat-label>
                <input
                  matInput
                  [ngxTimepicker]="pickerHS"
                  formControlName="exitTime"
                />
                <ngx-material-timepicker #pickerHS></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div style="flex: 0.2">
          <button
            mat-mini-fab
            color="warn"
            type="button"
            (click)="saveRegister(formR.value)"
          >
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>

      <!-- <div
        *ngIf="!edit"
        style="display: flex; flex-direction: row; justify-content: center"
      >
        <button
          type="submit"
          style="width: 70%; margin-top: 30px; align-self: center"
          color="primary"
          class="button-save mat-elevation-z5"
          mat-raised-button
        >
          Guardar
        </button>
      </div> -->
    </cdk-virtual-scroll-viewport>
  </form>
</ng-template>
